module.exports = __webpack_public_path__ + "media/src/images/icon/builder-d2c7666c5fc0ce95d80a11f5a96294e6.png";